export const zahlartenTh = {
  'zahlarten.header.title': 'วิธีการชำระเงิน',
  'zahlarten.header.subtitle': 'จัดการวิธีการชำระเงิน การเชื่อมโยง DATEV และช่องทางการชำระสำหรับใบแจ้งหนี้ขาเข้า',
  'zahlarten.header.newButton': 'เพิ่มวิธีการชำระเงิน',
  'zahlarten.readOnlyHint': 'ดูได้อย่างเดียว — การเพิ่ม แก้ไข ลบ หรือจัดเรียงต้องมีสิทธิ์ "แก้ไขการตั้งค่า"',

  'zahlarten.table.name': 'ชื่อ',
  'zahlarten.table.code': 'รหัส',
  'zahlarten.table.type': 'ประเภท',
  'zahlarten.table.zahlweg': 'ช่องทางการชำระ',
  'zahlarten.table.zahlwegTooltip': 'เรา (กิจการ) จะชำระใบแจ้งหนี้ขาเข้าด้วยวิธีการชำระนี้ผ่านช่องทางใด — กำหนดว่าจะแสดงตัวเลือกนี้เมื่อทำเครื่องหมายว่าใบแจ้งหนี้ขาเข้าชำระแล้วหรือไม่',
  'zahlarten.table.provider': 'ผู้ให้บริการ',
  'zahlarten.table.datevAccount': 'บัญชี DATEV',
  'zahlarten.table.active': 'ใช้งาน',
  'zahlarten.table.actions': 'การดำเนินการ',
  'zahlarten.table.empty': 'ยังไม่มีวิธีการชำระเงิน',
  'zahlarten.table.standardBadge': 'ค่าเริ่มต้น',
  'zahlarten.table.setZahlwegBadge': 'กำหนดช่องทางการชำระ',
  'zahlarten.table.editTitle': 'แก้ไข',
  'zahlarten.table.deleteTitle': 'ลบ',

  'zahlarten.modal.editTitle': 'แก้ไขวิธีการชำระเงิน',
  'zahlarten.modal.createTitle': 'เพิ่มวิธีการชำระเงิน',
  'zahlarten.modal.nameLabel': 'ชื่อ *',
  'zahlarten.modal.namePlaceholder': 'เช่น PayPal',
  'zahlarten.modal.descriptionLabel': 'คำอธิบาย',
  'zahlarten.modal.descriptionPlaceholder': 'คำอธิบายเพิ่มเติม (ไม่บังคับ)',
  'zahlarten.modal.typeLabel': 'ประเภท',
  'zahlarten.modal.providerLabel': 'ผู้ให้บริการ',
  'zahlarten.modal.providerPlaceholder': 'เช่น PayPal, Klarna',

  'zahlarten.modal.zahlwegLabel': 'ช่องทางการชำระสำหรับใบแจ้งหนี้ขาเข้า *',
  'zahlarten.modal.zahlwegTooltip': 'เรา (กิจการ) จะชำระใบแจ้งหนี้ของซัพพลายเออร์ด้วยวิธีการชำระนี้ผ่านช่องทางใด กำหนดว่าจะเลือกวิธีนี้ได้หรือไม่เมื่อทำเครื่องหมายใบแจ้งหนี้ขาเข้าว่าชำระแล้ว เลือก "ไม่มี" สำหรับช่องทางการขายล้วน ๆ (เช่น การซื้อด้วยใบแจ้งหนี้ของลูกค้าเราเอง หรือบัตรของขวัญ) — ซึ่งไม่สามารถใช้ชำระหนี้สินของเราเองได้',
  'zahlarten.modal.zahlwegPlaceholder': 'กรุณาเลือก …',
  'zahlarten.zahlwegOptions.kasse': 'เงินสด (แคชเชียร์)',
  'zahlarten.zahlwegOptions.bank': 'ธนาคาร (โอน/หักบัญชีอัตโนมัติ)',
  'zahlarten.zahlwegOptions.verrechnung': 'การหักกลบ (ส่วนลดเงินสด ใบลดหนี้จากซัพพลายเออร์ ฯลฯ)',
  'zahlarten.zahlwegOptions.keine': 'ไม่มี — ช่องทางการขายล้วน ๆ (เช่น ซื้อด้วยใบแจ้งหนี้ บัตรของขวัญ)',
  'zahlarten.zahlwegKurz.kasse': 'เงินสด',
  'zahlarten.zahlwegKurz.bank': 'ธนาคาร',
  'zahlarten.zahlwegKurz.verrechnung': 'หักกลบ',
  'zahlarten.zahlwegKurz.keine': 'ไม่มี',

  'zahlarten.modal.datevAccountLabel': 'เลขที่บัญชี DATEV',
  'zahlarten.modal.datevAccountTooltip': 'บัญชีที่ระบบแคชเชียร์บันทึกการชำระเงินประเภทนี้ ตัวอย่าง SKR03: 1000 = เงินสด, 1360 = บัญชีพักบัตร, 1400 = ลูกหนี้การค้า (ซื้อด้วยใบแจ้งหนี้), 1200 = ธนาคาร SKR04: 1600 / 1460 / 1200 / 1800',
  'zahlarten.modal.datevAccountPlaceholderInvoice': '1400 (SKR03)',
  'zahlarten.modal.datevAccountPlaceholderOther': 'เช่น 1360',
  'zahlarten.modal.datevBuKeyLabel': 'รหัสภาษี DATEV (BU-Schlüssel)',
  'zahlarten.modal.datevBuKeyPlaceholder': 'เช่น 10',

  'zahlarten.modal.invoicePaymentLabel': 'ซื้อด้วยใบแจ้งหนี้ (ลูกค้าชำระภายหลังผ่านใบแจ้งหนี้)',
  'zahlarten.modal.invoicePaymentTooltip': 'เปิดใช้งานเมื่อวิธีการชำระนี้หมายความว่าลูกค้าจะชำระค่าสินค้าภายหลังผ่านใบแจ้งหนี้ (เช่น "ซื้อด้วยเครดิต" "ชำระตามเงื่อนไข" "ใบแจ้งหนี้ B2B") ระบบแคชเชียร์จะไม่บันทึกรายได้ในไฟล์ส่งออก DATEV — รายได้จะถูกบันทึกโดยระบบ ERP เมื่อมีการออกใบแจ้งหนี้เท่านั้น เพื่อป้องกันการบันทึกรายได้ซ้ำซ้อน',
  'zahlarten.modal.invoicePaymentHint': 'ระบบแคชเชียร์ยังคงบันทึกรายการตามข้อกำหนดทางภาษี แต่จะไม่บันทึกรายได้ แนะนำบัญชี DATEV 1400 (SKR03) / 1200 (SKR04) สำหรับลูกหนี้การค้า',

  'zahlarten.modal.shipBeforePaymentLabel': 'จัดส่งก่อนได้รับการชำระเงิน',
  'zahlarten.modal.shipBeforePaymentTooltip': 'สินค้าสามารถออกจากร้านด้วยวิธีการชำระนี้ก่อนที่เงินจะเข้าได้หรือไม่ โดยทั่วไปใช้กับการซื้อด้วยใบแจ้งหนี้และเก็บเงินปลายทาง แต่ไม่ใช้กับการชำระล่วงหน้า คำสั่งซื้อที่ไม่อนุญาตจะไม่ปรากฏบนเครื่องมือถือสำหรับหยิบสินค้าเลย คำสั่งซื้อแบบมารับเองไม่ได้รับผลกระทบ — จะชำระเงินตอนส่งมอบ',
  'zahlarten.shipBefore.unsetTitle': 'ยังไม่กำหนด',
  'zahlarten.shipBefore.unsetText': 'ใช้ค่าที่รับมาจาก JTL หากไม่มีค่าจาก JTL สินค้าที่ยังไม่ชำระเงินจะถูกล็อกไว้จนกว่าจะทำเครื่องหมายว่าคำสั่งซื้อชำระแล้ว',
  'zahlarten.shipBefore.allowedTitle': 'อนุญาต',
  'zahlarten.shipBefore.allowedText': 'สินค้าสามารถออกได้แม้ยังไม่ได้ชำระเงิน — สำหรับการซื้อด้วยใบแจ้งหนี้ เก็บเงินปลายทาง หรือลูกค้าที่มีเงื่อนไขการชำระเงิน',
  'zahlarten.shipBefore.notAllowedTitle': 'ไม่อนุญาต',
  'zahlarten.shipBefore.notAllowedText': 'ต้องรอจนกว่าเงินจะเข้าก่อน คำสั่งซื้อจะยังไม่ปรากฏในขั้นตอนการหยิบสินค้าจนกว่าจะถึงเวลานั้น',

  'zahlarten.modal.onlineCheckoutLabel': 'เสนอในระบบสั่งซื้อออนไลน์ (Online-Checkout)',
  'zahlarten.modal.onlineCheckoutTooltip': 'ลูกค้าสามารถเลือกวิธีการชำระนี้เมื่อสั่งซื้อผ่านการสแกน (Scan-to-Order) หากระบุผู้ให้บริการเป็น \'paypal\' ลูกค้าจะชำระเงินออนไลน์ทันที — คำสั่งซื้อจะไปถึงแคชเชียร์ก็ต่อเมื่อยืนยันการชำระเงินแล้ว หากไม่ระบุผู้ให้บริการ จะชำระเงินที่แคชเชียร์ (เช่น "ชำระเมื่อมารับสินค้า")',
  'zahlarten.modal.onlineCheckoutHint': 'สำหรับ PayPal ให้ระบุผู้ให้บริการเป็น {{code}} เพิ่มเติม และตั้งค่าบัญชี DATEV 1210 (SKR03) / 1810 (SKR04)',

  'zahlarten.modal.shopLabel': 'เสนอในเว็บช็อป',
  'zahlarten.modal.shopTooltip': 'มีผลกับเว็บช็อปที่เชื่อมต่อไว้ — แยกจาก Online-Checkout ด้านบนซึ่งควบคุมการสั่งซื้อด้วยตนเองผ่านการสแกนในร้าน',
  'zahlarten.modal.shopHint': 'วิธีการชำระที่มีผู้ให้บริการ (PayPal, Stripe, Mollie) ต้องมีข้อมูลรับรองในเว็บช็อปและตั้งค่าที่นั่น — จะไม่ถูกถ่ายโอนจากที่นี่',

  'zahlarten.modal.conditionsHeading': 'เงื่อนไขการชำระเงิน',
  'zahlarten.modal.paymentTermsLabel': 'ระยะเวลาชำระเงิน (วัน)',
  'zahlarten.modal.paymentTermsPlaceholder': 'เช่น 14',
  'zahlarten.modal.discountPercentLabel': 'ส่วนลดเงินสด (%)',
  'zahlarten.modal.discountPercentPlaceholder': 'เช่น 2',
  'zahlarten.modal.discountDaysLabel': 'ระยะเวลาส่วนลดเงินสด (วัน)',
  'zahlarten.modal.discountDaysPlaceholder': 'เช่น 10',
  'zahlarten.modal.orderConfirmationTextLabel': 'ข้อความสำหรับใบยืนยันคำสั่งซื้อ',
  'zahlarten.modal.orderConfirmationTextPlaceholder': 'เช่น ชำระภายใน 14 วัน ส่วนลด 2% หากชำระภายใน 10 วัน',
  'zahlarten.modal.invoiceTextLabel': 'ข้อความสำหรับใบแจ้งหนี้',
  'zahlarten.modal.invoiceTextPlaceholder': 'เช่น กรุณาโอนเงินภายใน 14 วัน',

  'zahlarten.modal.activeLabel': 'ใช้งาน',
  'zahlarten.modal.defaultLabel': 'วิธีการชำระเงินเริ่มต้น',
  'zahlarten.modal.cancelButton': 'ยกเลิก',
  'zahlarten.modal.saveButton': 'บันทึก',
  'zahlarten.modal.createButton': 'สร้าง',

  'zahlarten.errors.nameRequired': 'กรุณากรอกชื่อ',
  'zahlarten.errors.zahlwegRequired': 'กรุณาเลือกช่องทางการชำระ — ระบุว่าวิธีการชำระนี้ใช้ชำระใบแจ้งหนี้ขาเข้าด้วยช่องทางใด',
  'zahlarten.errors.saveFailedPrefix': 'บันทึกไม่สำเร็จ: ',
  'zahlarten.errors.toggleFailedPrefix': 'สลับสถานะไม่สำเร็จ: ',
  'zahlarten.errors.deleteFailedPrefix': 'ลบไม่สำเร็จ: ',
  'zahlarten.errors.loadFailed': 'โหลดวิธีการชำระเงินไม่สำเร็จ',
  'zahlarten.errors.unknown': 'ข้อผิดพลาดที่ไม่ทราบสาเหตุ',
  'zahlarten.errors.forbidden': 'การดำเนินการนี้ต้องมีสิทธิ์ "แก้ไขการตั้งค่า"',

  'zahlarten.delete.title': 'ลบวิธีการชำระเงินนี้หรือไม่?',
  'zahlarten.delete.text': 'ต้องการลบวิธีการชำระเงินนี้จริงหรือไม่ การดำเนินการนี้ไม่สามารถย้อนกลับได้',
  'zahlarten.delete.cancelButton': 'ยกเลิก',
  'zahlarten.delete.confirmButton': 'ลบ',

  'zahlarten.types.prepayment': 'ชำระล่วงหน้า',
  'zahlarten.types.invoice': 'ใบแจ้งหนี้',
  'zahlarten.types.online': 'ชำระเงินออนไลน์',
  'zahlarten.types.cash': 'เงินสด',
  'zahlarten.types.other': 'อื่น ๆ',

  'zahlarten.myPortal.sectionTitle': 'ช่องทางการชำระสำหรับใบแจ้งหนี้ขาเข้า',
  'zahlarten.myPortal.sectionText': 'มีวิธีการชำระใดให้เลือกบ้างเมื่อทำเครื่องหมายว่าใบแจ้งหนี้ขาเข้า (ใบแจ้งหนี้จากซัพพลายเออร์) ชำระแล้ว — และชำระด้วยช่องทางใดจริง (เงินสด ธนาคาร หรือการหักกลบ)',

  'zahlarten.configSection.readOnlyHint': 'การเปลี่ยนแปลงนี้ต้องมีสิทธิ์ "แก้ไขการตั้งค่า"',
  'zahlarten.configSection.forbidden': 'การดำเนินการนี้ต้องมีสิทธิ์ "แก้ไขการตั้งค่า"',
};
